import { useSyncExternalStore } from 'react';
import {
  getConsentSnapshot,
  getServerConsentSnapshot,
  subscribeConsent,
  type ConsentSnapshot,
} from '../lib/consentStore';

/** Where the visitor's privacy choice stands. Reads as `pending` on the server and while hydrating. */
export function useConsent(): ConsentSnapshot {
  return useSyncExternalStore(subscribeConsent, getConsentSnapshot, getServerConsentSnapshot);
}
